import React from 'react';
import ListPage from '../../base/ListPage.js';
import APILXD from '../../../http/APILXD.js';
import {Modal, message, Popover, Descriptions, Image} from 'antd';
import TimeHelp from "../../../tool/TimeHelp";
import HttpTool from "../../../tool/HttpTool";
import styles from "./index.less";
import ModalDelete from "../../../components/modalDelete/ModalDelete";

const MD = new ModalDelete()

export default class ProtocolList extends ListPage {
  constructor(props) {
    super(props);
  }

  base_getListConfig() {
    return {
      table: {
        columns: this.getTableColumns(),
        url: APILXD.getAgreementList,
        otherParam: {
          groupId: this.props.groupId
        },
      },
      new: {
        defaultValue: '新增协议',
        action: () => {
          this.props.openTab({
            path: 'ProtocolEdit',
            title: '新增协议',
            post: {
              parent: this.props,
              data: null,
              groupId: this.props.groupId,
            }
          })
        }
      },
      search: {
        seniorSearch: this.getSeniorSearch(),
        option: {
          openSenior: true,
          placeholder: '请输入协议名称搜索',
          reg: /^[\s\S]*$/,
          beforeSubmit: (value) => {
            if (value.keyword) {
              value.name = value.keyword
            }
            if(value.enable){
              value.enable = value.enable === 1
            }
            delete value.keyword

            return true;
          },
        }
      }
    }
  }

  getSeniorSearch() {
    return {
      colCount: 3,
      formItemLayout: {
        labelCol: {span: 6},
        wrapperCol: {span: 18, offset: 0},
      },
      parameterArr: [
        {
          field: "enable",
          name: "状态",
          type: 'select',
          selectType: 'value',
          reg: (v) => {
            return true;
          },
          option: {
            allowClear: true,
          },
          data: [
            {
              title: '上线',
              value: 1,
            },
            {
              title: '下线',
              value: 2,
            },
          ]
        },
      ],
    }
  }

  /**
   *  列表数据配置
   */
  getTableColumns() {
    return [
      {
        title: '协议名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '状态',
        dataIndex: 'enable',
        key: 'enable',
        render: (text) => {
          return text ? <span style={{color: 'dodgerblue'}}>已上线</span> :
            <span style={{color: 'darkorange'}}>已下线</span>
        }
      },
      {
        title: '操作',
        width: 220,
        render: (text, record, index) => {
          return (
            <div>
              {
                this.powerConfig.Edit
                  ? (record.enable ? <span onClick={() => {
                      this.changeState(record._id, false)
                    }} style={{color: "darkorange"}} className={styles.btnCopy}>{"下线协议"}</span> :
                    <span onClick={() => {
                      this.changeState(record._id, true)
                    }} style={{color: "dodgerblue"}} className={styles.btnEdit}>{"上线协议"}</span>)
                  : null
              }
              {
                this.powerConfig.Edit
                  ?  <span onClick={() => {
                          this.props.openTab({
                            path: 'ProtocolEdit',
                            title: '修改协议',
                            post: {
                              parent: this.props,
                              data: record,
                              groupId: this.props.groupId,
                            }
                          })
                  }} className={styles.btnEdit}>{"修改"}</span>
                  : null
              }
              {
                this.powerConfig.Delete
                  ?  <span onClick={() => {
                    MD.show({
                        title: "提示",
                        okTitle: "确定",
                        closeTitle: "取消",
                      },
                      {}
                      ,
                      {
                        otherParam: {_id: record._id},
                        content: record.name,
                        url: APILXD.delAgreement,
                        apiType: 'post',
                        callBack: (state) => {
                          //删除成功回调
                          if(state === "success"){
                            if(this.items?.length === 1 && this.state.page > 1){
                              //当前页的最后一条
                              this.setState({
                                page: this.state.page - 1
                              },()=>{
                                this._loadDataForNet();
                              })
                            }else{
                              this._loadDataForNet();
                            }
                          }
                        }
                      });
                  }} className={styles.btnDelete}>{"删除"}</span>
                  : null
              }
            </div>
          )
        }
      },
    ]
  }

  changeState(id, enable) {
    Modal.confirm({
      title: '提示',
      content: "确定" + (enable ? "上线" : "下线") + "该协议吗？",
      okText: '确定',
      cancelText: '取消',
      onOk: () => {
        let param = {
          _id: id,
          enable,
        };
        let successCB = (code, msg, json, option) => {
          this.setState({loading: false}, () => {
            message.success('操作成功');
            this._loadDataForNet();
          });
        };
        let failureCB = (code, msg) => {
          this.setState({loading: false}, () => {
            message.error(msg);
          });
        };

        this.setState({loading: true});

        HttpTool.post(APILXD.agreementDisable, successCB, failureCB, param);
      }
    })
  }
}